(ns manatee.qa.view.item
  "The view of a single answer item that has no edits."
  (:require [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.annotation.components :as annotation-components]
            [manatee.components.item :as annotation-item]
            [manatee.qa.subs :as subs]
            [manatee.qa.view.shared :as view-shared]
            [manatee.ui.templates :as templates]
            [re-frame.core :as rf]
            [rothko.button.component :refer [button]]
            [rothko.icon-animated.component :refer [spinner]]
            [rothko.layout.component :refer [layout]]
            [rothko.panel.component :refer [panel]]))

(defn item-body
  [task-config item]
  [:<>
   [layout {:appearance #{:qa-view-details}}
    [view-shared/item-details task-config item]]
   (when (:short-rubric item)
     [:p (:short-rubric item)])
   [annotation-item/annotate-item item {:read-only? true
                                        :hide-toolbar? true
                                        :autosaving-disabled? true
                                        :spellcheck-disabled? true
                                        :scoring-disabled? true}]
   [:div.action-buttons
    (if (view-shared/go-back-only?)
      [view-shared/go-back-button]
      [button {:appearance #{:secondary :full-width}
               :on-click #(rf/dispatch [:navigate-to [:manatee.edit.handlers/edits]])}
       "View all edits"])]])

(defn item-qa-loading-component-wrapper
  [loading-text component]
  (let [qa-loading @(rf/subscribe [::subs/qa-loading])]
    [:div.qa-view-container
     [annotation-components/alert-container]
     [panel {:appearance #{:primary}}
      (if qa-loading
        [:div
         [:h4 loading-text]
         [spinner {:size 20}]]
        component)]]))

(defn item-container
  []
  (let [item @(rf/subscribe [::subs/item])
        task-config @(rf/subscribe [::task-config-subs/task-config (get-in item [:task-config-id])])]
    (item-qa-loading-component-wrapper "Loading item.." [item-body task-config item])))

(def item-page
  {:template templates/single-column
   :main item-container})
